import { render, staticRenderFns } from "./RoastingSummary.vue?vue&type=template&id=2ed2d75f&scoped=true&"
import script from "./RoastingSummary.vue?vue&type=script&lang=ts&"
export * from "./RoastingSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed2d75f",
  null
  
)

export default component.exports